import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import { useCallback } from 'react';

import { useDispatch, useSelector } from 'app/store';
import {
  devicesDeviceChannelUsageSelector,
  devicesDeviceVariantFrequencyLabelSelector,
  devicesDeviceVariantParamsUpdate,
  devicesDeviceVariantSelector,
} from 'modules/devices/slice';
import { trackEventDebounced } from 'utils/googleAnalytics';

import ChannelUsageSlider, { ChannelUsageSliderProps } from '../components/elements/ChannelUsageSlider';

const ChannelUsageSliderContainer = (props: Partial<ChannelUsageSliderProps>) => {
  const { leftId } = useBottomPanel();

  const value = useSelector((state) => (leftId ? devicesDeviceChannelUsageSelector(state, leftId) : undefined));
  const variant = useSelector((state) => (leftId ? devicesDeviceVariantSelector(state, leftId) : undefined));
  const frequencyLabel = useSelector((state) =>
    leftId ? devicesDeviceVariantFrequencyLabelSelector(state, leftId) : undefined
  );
  const label = `${frequencyLabel ? `${frequencyLabel} ` : ''}Channel Usage`;

  const dispatch = useDispatch();

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const channelUsage = Number(event.target.value);
      if (leftId && variant != null) {
        dispatch(devicesDeviceVariantParamsUpdate({ id: leftId, variant, changes: { channelUsage } }));
        trackEventDebounced('bottomPanelChannelUsageChange', { variant, channelUsage });
      }
    },
    [leftId, variant, dispatch]
  );

  if (!leftId || value == null) {
    return null;
  }

  return <ChannelUsageSlider onChange={onChange} label={label} value={value} {...props} />;
};

export default ChannelUsageSliderContainer;
